'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

const uuid = require('uuid/v4');

import routes from './survey-editor.routes';

export class SurveyEditorComponent {
  constructor($stateParams, $scope, dialogs, SurveysService, VoterGroupsService, SettingsService, $state, StorageService, $uibModal) {
    'ngInject';
    this.surveyId = $stateParams.id;
    this.$scope = $scope;
    this.$state = $state;
    this.dialogs = dialogs;
    this.SurveysService = SurveysService;
    this.VoterGroupsService = VoterGroupsService;
    this.StorageService = StorageService;
    this.$uibModal = $uibModal;

    this.fieldTypes = ["text", "textbox", "number", "yes/no", "select", "ranking", "image", "help", "recipient"];
    this.prefillTypes = [{
      type: "name:first",
      name: "First Name",
      group: "Name"
    }, {
      type: "name:last",
      name: "Last Name",
      group: "Name"
    }, {
      type: "name:full",
      name: "Full Name",
      group: "Name"
    }, {
      type: "profile:email",
      name: "Email",
      group: "Profile"
    }, {
      type: "profile:phone",
      name: "Phone",
      group: "Profile"
    }, {
      type: "profile:building",
      name: "Building #",
      group: "Profile"
    }, {
      type: "profile:unit",
      name: "Unit #",
      group: "Profile"
    }, {
      type: "profile:street",
      name: "Street",
      group: "Profile"
    }, {
      type: "profile:address",
      name: "Address",
      group: "Profile"
    }, {
      type: "date:shortDate",
      name: "Short Date (e.g. 9/6/18)",
      group: "Date and Time"
    }, {
      type: "date:mediumDate",
      name: "Medium Date (e.g. Sep 6, 2018)",
      group: "Date and Time"
    }, {
      type: "date:longDate",
      name: "Long Date (e.g. September 6, 2018)",
      group: "Date and Time"
    }, {
      type: "date:fullDate",
      name: "Full Date (e.g. Thursday, September 6, 2018)",
      group: "Date and Time"
    }, {
      type: "date:short",
      name: "Date and Time (e.g. 9/6/18 9:02 AM)",
      group: "Date and Time"
    }];

    this.toolbarDefinition = [
      ["bold", "italics", "underline"],
      ["h3", "h4", "h5"],
      ["p", "clear"],
      ["ul", "ol"],
      ["archiveImageLink", "insertImage", "insertLink"],
      ["html"]
    ];

    this.layoutTypes = [{
      name: "Full Width (100%)",
      value: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
    }, {
      name: "Half Width (50%)",
      value: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
    }, {
      name: "Quarter Width (25%)",
      value: "col-xs-12 col-sm-12 col-md-3 col-lg-3"
    }];

    this.sortableOptions = {
      handle: '.handle'
    };

    this.assets = [];
    this.totalAttachmentSize = _ => this.assets.reduce((totalSize, asset) => totalSize + asset.size, 0);

    this.fields = [];
    this.form = ['*'];
    this.model = {};
    this.recipients = "";

    this.survey = {
      formSchema: {
        "type": "object",
        "properties": {}
      },
      campaign: {
        mailSubject: "New Survey",
        mailText: "<p>A new survey is available</p>"
      }
    };

    SettingsService.getByName({name: 'client'}, settings => {
      this.useSuite = settings.data.useSuite;

      this.selectedVoterGroup = null;

      let VG_QUERY_METHOD = (this.useSuite) ? "querySuite" : "query";

      VoterGroupsService[VG_QUERY_METHOD](data => {
        this.voterGroups = data.filter(vg => vg.type == 'properties');

        if (this.surveyId) {
          this.SurveysService.get({id: this.surveyId}, survey => {
            this.survey = survey;

            this.assets = survey.campaign.attachments;
            this.assets.forEach(asset => {
              this.StorageService.getFileSize({id: asset._id}, data2 => {
                asset.size = 4*(data2.size/3); // calc base64 size (as 10MB is hard limit after base64 encoding)
              });
            });

            if (this.survey.deadline)
              this.survey.deadline = new Date(this.survey.deadline);

            this.createFields();
            this.preview();
          })
        }
      });
    });
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  removeAttachment(idx) {
    this.assets.splice(idx,1);
  }

  removeDeadline() {
    this.survey.deadline = null;
  }


  openAssetUploadModalAttachment() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'application/pdf,image/*'
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        result.forEach(storageId => {
          that.StorageService.getMeta({id: storageId}, data => {
            that.StorageService.getFileSize({id: storageId}, data2 => {
              data.size = 4*(data2.size/3); // calc base64 size (as 10MB is hard limit after base64 encoding)
              that.assets.push(data);
            });
          }, err => {
            console.log('could not retrieved storage from server');
          });

        });

      },
      function () { /* cancel */ }
    );

  }

  deleteField($event, field, idx) {
    $event.stopPropagation();

    var dlg = this.dialogs.confirm("Delete Field?", "Do you really want to delete the field '" + field.title + "'?");
    dlg.result.then(() => {
      this.fields.splice(idx,1);
    }, () => {
      // Cancel
    });

  }

  createFields() {
    this.fields = [];

    let keys = Object.keys(this.survey.formSchema.properties);
    let requiredFields = this.survey.formSchema.required || [];

    console.log("schemaForm.properties");
    console.log(this.survey.formSchema.properties)

    keys.forEach(key => {
      let oSchemaField = this.survey.formSchema.properties[key];

      let fieldDef = {
        key: key,
        title: oSchemaField.title || '',
        description: oSchemaField.description || '',
        required: requiredFields.indexOf(key) !== -1,
        hideFieldInResult: oSchemaField.hideFieldInResult || false
      };

      if (oSchemaField["x-schema-form"] && oSchemaField["x-schema-form"].htmlClass) {
        fieldDef.layout = oSchemaField["x-schema-form"].htmlClass;
      }

      switch (oSchemaField.type) {
        case 'string':
          if (oSchemaField.enum) {
            if (oSchemaField.recipient) {
              fieldDef.type = 'recipient';
            } else {
              fieldDef.type = 'select';
            }
            fieldDef.enum = oSchemaField.enum;
          } else if (oSchemaField["x-schema-form"] ) {

            if (oSchemaField["x-schema-form"]["type"] == 'textarea') {
              fieldDef.type = 'textbox';
            } else if (oSchemaField["x-schema-form"]["type"] == 'help') {
              fieldDef.type = 'help';
              fieldDef.helpvalue = oSchemaField["x-schema-form"]["helpvalue"];
            } else {
              fieldDef.type = 'text';
            }

            if (oSchemaField["x-schema-form"].readonly) {
              fieldDef.readonly = true;
            }

          } else {
            fieldDef.type = 'text';
          }
          break;
        case 'number':
          fieldDef.type = 'number';
          fieldDef.showStatsInResult = oSchemaField.showStatsInResult || false;
          break;
        case 'boolean':
          fieldDef.type = 'yes/no';
          break;
        case 'array':
          if (oSchemaField.format == 'ranking') {
            fieldDef.type = 'ranking';
            fieldDef.enum = oSchemaField.enum;
          }
          else
            fieldDef.type = 'image';
          break;
      }

      if (oSchemaField["x-prefilled"]) {
        fieldDef.prefill = true;
        fieldDef.prefilled = oSchemaField["x-prefilled"];
      }

      this.fields.push(fieldDef);
    });

    console.log("fields");
    console.log(this.fields);
  }

  removeChoice(field, idx) {
    field.enum.splice(idx,1);
  }

  addChoice(field) {
    if (!field.hasOwnProperty("enum")) {
      field.enum = [""];
    } else {
      field.enum.push("");
    }
  }

  preview() {
    this.survey.formSchema.properties = {};
    this.survey.formSchema.required = [];

    this.fields.forEach(field => {

      let fieldDef = {
        title: field.title,
        key: field.key,
        description: field.description,
        layout: field.layout || 'col-xs-12 col-sm-12 col-md-12 col-lg-12',
        hideFieldInResult: field.hideFieldInResult || false
      };

      if (field.required && field.type != 'help') {
        this.survey.formSchema.required.push(field.key);
      }

      switch (field.type) {
        case 'text':
          fieldDef.type = 'string';
          if (field.prefill && field.prefilled) {
            fieldDef["x-prefilled"] = field.prefilled;
          }
          if (field.readonly) {
            fieldDef["x-schema-form"] = {
              readonly: true
            }
          }
          break;
        case 'textbox':
          fieldDef.type = 'string';
          fieldDef["x-schema-form"] = {
            "type": "textarea"
          };
          if (field.prefill && field.prefilled) {
            fieldDef["x-prefilled"] = field.prefilled;
          }
          if (field.readonly) {
            fieldDef["x-schema-form"].readonly = true;
          }
          break;
        case 'number':
          fieldDef.type = 'number';
          fieldDef.showStatsInResult = field.showStatsInResult || false;
          break;
        case 'yes/no':
          fieldDef.type = 'boolean';
          break;
        case 'select':
          fieldDef.type = 'string';
          fieldDef.enum = field.enum || [];
          fieldDef["x-schema-form"] = {
            "placeholder": "- Select -"
          };
          break;
        case 'ranking':
          fieldDef.type = 'array';
          fieldDef.format = "ranking";
          fieldDef.enum = field.enum || [];
          fieldDef.items = {type: "string"};

          // Init ranking array for preview
          this.model[fieldDef.key] = angular.copy(fieldDef.enum);
          break;
        case 'image':
          fieldDef.type = 'array';
          fieldDef.format = 'singlefile';
          fieldDef.pattern = {
            "mimeType": "image/*"
          };
          fieldDef["x-schema-form"] = {
            "type": "nwpFileUpload",
            "endpoint": "/api/storage"
          };
          break;
        case 'help':
          fieldDef.type = 'string';
          fieldDef["x-schema-form"] = {
            "type": "help",
            "helpvalue": field.helpvalue
          };
          break;
        case 'recipient':
          fieldDef.type = 'string';
          fieldDef.recipient = true;
          fieldDef.enum = recipientGroups || [];
          fieldDef["x-schema-form"] = {
            "placeholder": "- Select -"
          };
          break;
      }

      if (!fieldDef["x-schema-form"]) {
        fieldDef["x-schema-form"] = {};
      }

      fieldDef["x-schema-form"].htmlClass = field.layout || 'col-xs-12 col-sm-12 col-md-12 col-lg-12';

      this.survey.formSchema.properties[field.key] = fieldDef;
    });

    this.$scope.$broadcast('schemaFormRedraw');
  }

  addField() {
    let idx = this.fields.length+1;
    this.fields.push({
      key: uuid(),
      title: 'Field ' + idx,
      type: 'text',
      layout: 'col-xs-12 col-sm-12 col-md-12 col-lg-12'
    })
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = data => {
        var actionString = (this.survey) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "Your survey has been "+actionString+" successfully");
        dlg.result.then(() => {
            that.$state.go("survey-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.preview();

      this.survey.fields = this.fields;

      this.survey.campaign.attachments = this.assets.map(asset => {
        return asset._id;
      });

      if (this.surveyId) {  // Save changes on the current image gallery
        this.SurveysService.update({id: this.surveyId}, this.survey, onSuccess, onError);
      } else { // Create a new image gallery
        this.SurveysService.save(this.survey, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.survey.editor', [uiRouter])
  .config(routes)
  .component('surveyEdit', {
    template: require('./survey-editor.html'),
    controller: SurveyEditorComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/edit/survey-editor.component.js